module.exports = __webpack_public_path__ + "fonts/butler_bold-webfont.3b6db30.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/butler/butler_bold-webfont.woff
// module id = 556
// module chunks = 0